import { createDuck } from 'helpers/duckTools';

export const experimentDuck = createDuck('EXPERIMENT', {});

export const reducer = experimentDuck;
